/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_DeletingInputs */

const en_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting API Key. Please wait...`)
};

const fr_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression de la clé API. Veuillez patienter...`)
};

const de_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel wird gelöscht. Bitte warten...`)
};

const it_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminazione della chiave API. Attendi...`)
};

const ru_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление ключа API. Пожалуйста, подождите...`)
};

const es_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando clave API. Espere...`)
};

const zh_cn2_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在删除 API 密钥。请稍候……`)
};

const ja_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIキーを削除しています。お待ちください...`)
};

const hi_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एपीआई कुंजी हटाई जा रही है। कृपया प्रतीक्षा करें...`)
};

const pt_pt2_options_api_keys_deleting = /** @type {(inputs: Options_Api_Keys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluindo a chave da API. Aguarde...`)
};

/**
* | output |
* | --- |
* | "Deleting API Key. Please wait..." |
*
* @param {Options_Api_Keys_DeletingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_deleting = /** @type {((inputs?: Options_Api_Keys_DeletingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_DeletingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_deleting(inputs)
	if (locale === "de") return de_options_api_keys_deleting(inputs)
	if (locale === "it") return it_options_api_keys_deleting(inputs)
	if (locale === "ru") return ru_options_api_keys_deleting(inputs)
	if (locale === "es") return es_options_api_keys_deleting(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_deleting(inputs)
	if (locale === "ja") return ja_options_api_keys_deleting(inputs)
	if (locale === "hi") return hi_options_api_keys_deleting(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_deleting(inputs)
	return en_options_api_keys_deleting(inputs)
});